import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { withRouter } from 'react-router-dom';
import { NotifContext } from './NotifContext';

const blogAPI = process.env.REACT_APP_API;

export const ProfileContext = createContext();

const ProfileContextProvider = (props) => {
  const anonymousUser = {
    userData: {
      settings: {
        private: false,
        searchable_profile: false,
      },
      user_uid: 'anonymous_user',
      user: {
        createdAt: Date.now(),
        name: {
          firstName: 'Anonymous',
          lastName: '',
          fullName: 'Anonymous',
        },
        picture:
          'https://res.cloudinary.com/codepark-in/image/upload/v1540543932/cp-user-avatars/049-robot-8.png',
        uid: 'rand0m_uid',
        email: 'unavailable',
      },
      uid: 'rand0m_uid',
    },
    total_updates: 0,
  };

  const config = { withCredentials: true };

  const [profile, setProfile] = useState(anonymousUser);
  const [loggedin, setLoggedin] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [personalProfile, setPersonalProfile] = useState(true);
  const [showProfile, setShowProfile] = useState(false);
  const [profileLoader, setProfileLoader] = useState(false);
  const [updateSettingsLoader, setUpdateSettingsLoader] = useState(null);
  const { show } = useContext(NotifContext);
  const [followingLoader, setFollowingLoader] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [users, setUsers] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [usersLoader, setUsersLoader] = useState(false);
  const [helpCenterVisibility, setHelpCenterVisibility] = useState(false);

  const openProfileDrawer = () => {
    setShowProfile(true);
  };

  const closeProfileDrawer = () => {
    setShowProfile(false);
  };

  const openUsersDrawer = () => {
    setShowUsers(true);
  };

  const closeUsersDrawer = () => {
    setShowUsers(false);
  };

  const openHelpCenter = () => {
    setHelpCenterVisibility(true);
  };

  const closeHelpCenter = () => {
    setHelpCenterVisibility(false);
  };

  const updateSettings = (prop, value) => {
    setUpdateSettingsLoader(prop);
    const api = `${blogAPI}/u/update`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .post(
          api,
          {
            prop,
            value,
          },
          config
        )
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Backend Error: update settings', {
              api,
              response,
              has_token: Boolean(config.headers.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setProfile(response.payload);
            localStorage.setItem('user', JSON.stringify(response.payload));
            localStorage.setItem('loggedin', true);
          }
          setUpdateSettingsLoader(null);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: update settings', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'topLeft');
          setUpdateSettingsLoader(null);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
      setProfile(anonymousUser);
      localStorage.setItem('loggedin', false);
      setUpdateSettingsLoader(null);
    }
    // show('success','Update on privacy changes',`We have successfully changed your privacy to ${updatedProfile}`);
  };

  const fetchProfile = (currentUser) => {
    const {
      match: { params },
    } = props;

    setProfileLoader(true);
    const api = `${blogAPI}/u/fetch/${currentUser}`;
    if (localStorage.getItem('loggedin') === 'true' && currentUser) {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Backend Error: fetch profile', {
              api,
              response,
              has_token: Boolean(config.headers.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setProfile(response.payload);
            setPersonalProfile(
              Boolean(!params.uid || params.uid === profile.userData.uid)
            );
            localStorage.setItem('user', JSON.stringify(response.payload));
            localStorage.setItem('loggedin', true);
          }
          setProfileLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Fetch profile', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'topLeft');
          setProfileLoader(false);
        });
    } else {
      show('info', 'Error!', `You are logged in as anonymous user`, 'topLeft');
      setProfile(anonymousUser);
      localStorage.setItem('loggedin', true);
    }
  };

  const getUsers = () => {
    setUsersLoader(true);
    const pointer = users.length || 0;
    const api = `${blogAPI}/u/following?pointer=${pointer}`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Backend Error: Fetch users', {
              api,
              response,
              has_token: Boolean(config.headers.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setUsers(response.payload.users);
            localStorage.setItem(
              'followers',
              JSON.stringify(response.payload.users)
            );
          }
          setUsersLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Fetch users', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'topLeft');
          setUsersLoader(false);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
    }
  };

  const followUser = (uid) => {
    const {
      match: { params },
    } = props;
    const api = `${blogAPI}/u/subscribe/${params.uid || uid}`;
    setFollowingLoader(true);
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Backend Error: Follow user', {
              api,
              response,
              has_token: Boolean(config.headers.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setIsFollowing(response.subscribed);
            if (users.length > 0) {
              for (let i = 0; i < users.length; i += 1) {
                if (users[i].app_profile_uid === uid)
                  users[i].current_user_follows = response.subscribed;
              }
            }
          }
          setFollowingLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Follow user', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'topLeft');
          getUsers();
          setFollowingLoader(false);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
      setProfile(anonymousUser);
      localStorage.setItem('loggedin', false);
      setFollowingLoader(false);
    }
  };

  useEffect(() => {
    const {
      match: { params },
    } = props;

    fetch('https://api.rajchandra.me/identity/auth/me', {
      credentials: 'include',
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && !data.error) {
          const u = data.data.user;
          // eslint-disable-next-line no-underscore-dangle
          const uid = u._id;
          const mapped = {
            userData: {
              settings: { private: false, searchable_profile: false },
              user_uid: uid,
              user: {
                createdAt: u.createdAt,
                name: u.name,
                picture: u.picture,
                uid,
                email: u.email,
              },
              uid,
            },
            total_updates: 0,
          };
          setProfile(mapped);
          localStorage.setItem('user', JSON.stringify(mapped));
          localStorage.setItem('loggedin', true);
          setLoggedin(true);
          setPersonalProfile(Boolean(!params.uid || params.uid === uid));
        } else {
          localStorage.setItem('loggedin', false);
          setProfile(anonymousUser);
          setLoggedin(false);
          setPersonalProfile(false);
        }
        setAuthChecked(true);
      })
      .catch(() => {
        localStorage.setItem('loggedin', false);
        setProfile(anonymousUser);
        setLoggedin(false);
        setPersonalProfile(false);
        setAuthChecked(true);
      });
  }, []);

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
        loggedin,
        authChecked,
        fetchProfile,
        showProfile,
        setShowProfile,
        updateSettings,
        profileLoader,
        setProfileLoader,
        updateSettingsLoader,
        setUpdateSettingsLoader,
        openProfileDrawer,
        closeProfileDrawer,
        personalProfile,
        setPersonalProfile,
        followingLoader,
        setFollowingLoader,
        followUser,
        isFollowing,
        setIsFollowing,
        users,
        setUsers,
        getUsers,
        showUsers,
        setShowUsers,
        openUsersDrawer,
        closeUsersDrawer,
        usersLoader,
        helpCenterVisibility,
        openHelpCenter,
        closeHelpCenter,
      }}
    >
      {props.children}
    </ProfileContext.Provider>
  );
};

export default withRouter(ProfileContextProvider);
